var resumeParsed = function resumeParsed(data) {
  return {
    type: 'RESUME_PARSED',
    data: data
  };
};
var reinitializeResume = function reinitializeResume() {
  return {
    type: 'REINITIALIZE_RESUME'
  };
};
var linkedinProfileParsed = function linkedinProfileParsed(data) {
  return {
    type: 'LINKEDIN_PROFILE_PARSED',
    data: data
  };
};
var profileSuggestionsParsed = function profileSuggestionsParsed(data) {
  return {
    type: 'PROFILE_SUGGESTIONS_PARSED',
    data: data
  };
};
var updateBio = function updateBio(data) {
  return {
    type: 'UPDATE_BIO',
    data: data
  };
};
var updateLocation = function updateLocation(data) {
  return {
    type: 'UPDATE_LOCATION',
    data: data
  };
};
var updateArray = function updateArray(id, newArray) {
  return {
    type: 'UPDATE_ARRAY',
    data: {
      id: id,
      newArray: newArray
    }
  };
};
export default {
  resumeParsed: resumeParsed,
  reinitializeResume: reinitializeResume,
  linkedinProfileParsed: linkedinProfileParsed,
  profileSuggestionsParsed: profileSuggestionsParsed,
  updateBio: updateBio,
  updateLocation: updateLocation,
  updateArray: updateArray
};